export default __webpack_public_path__ + "static/media/panel-process.d2589f5a.svg";